import { USER_LOGIN, USER_LOGOUT } from './types';

let initialState = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {
    token: null,
    role: null,
    refreshToken: null,
    isAuthenticated: false,
    user: null
}

const authReducer = (state = initialState, action) => {
    switch (action.type){
        case USER_LOGIN:
            return {
                ...state,
                isAuthenticated: true,
                token: action.token,
                role: action.role,
                refreshToken: action.refreshToken,
                user: action.user
            }
        case USER_LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                token: null,
                role: null,
                refreshToken: null,
              };
        default:
            return state;
    }
}

export default authReducer;